import { Flex } from "antd";
import { styled } from "styled-components";

export const StyledInnerForm = styled(Flex)`
  background: var(--color-base-White);
  border-radius: var(--radius-md-lrg);
  padding: 16px 16px 32px 16px;
  width: 100%;
`;
